<rask-header [uppercase]="true">
  Virkesköp
</rask-header>

<rask-sysadm-move-avtal></rask-sysadm-move-avtal>

<rask-container-block>
  <ng-container header>Extern virkeskop kör om dokument</ng-container>
  <div class="row">
    <div class="col-12">
      <rask-input label="dokumentnyckel" [(ngModel)]="dokumentnyckel"></rask-input>
      <rask-input label="status" [(ngModel)]="dokumentStatus" placeholder="Uppdaterad"></rask-input>
    </div>
  </div>
  <ng-container footer>
    <rask-button color="secondary" (click)="skickaOmDokument()">kör</rask-button>
  </ng-container>
</rask-container-block>
